import React from 'react';
import PropTypes from 'prop-types';
import { preloadPageForRoute } from '../../util/pagePreload';

const Form = props => {
  const { children, contentRef, enforcePagePreloadFor, onSubmit, ...restProps } = props;

  const handleSubmit = event => {
    preloadPageForRoute(enforcePagePreloadFor);
    if (onSubmit) {
      return onSubmit(event);
    }
    return undefined;
  };

  const formProps = {
    // These are mainly default values for the server
    // rendering. Otherwise the form would submit potentially
    // sensitive data with the default GET method until the client
    // side code is loaded.
    method: 'post',
    action: '/',

    // allow content ref function to be passed to the form
    ref: contentRef,
    onSubmit: handleSubmit,

    ...restProps,
  };
  return <form {...formProps}>{children}</form>;
};

Form.defaultProps = {
  children: null,
  contentRef: null,
  enforcePagePreloadFor: null,
  onSubmit: null,
};

const { func, node, string } = PropTypes;

Form.propTypes = {
  children: node,
  contentRef: func,
  enforcePagePreloadFor: string,
  onSubmit: func,
};

export default Form;
